import ExtendedFilterMenuController from "controllers/components/expanded_filter_menu_controller"

export default class extends ExtendedFilterMenuController {
  applyFilters(e) {
    location.hash = "tunnel_operator"
    location.search = this.search.toString()
  }

  get search() {
    let search = this.searchFromFilters

    for (let select of $(this.filtersTarget).find("select")) {
      if (select.multiple) {
        let filterName = `tunnel_operator_filters[${select.name.replace("[]", "")}][]`
        $(select).val().forEach((val) => {
          search.append(filterName, val)
        })
      } else {
        let filterName = `tunnel_operator_filters[${select.name}]`
        if($(select).val().length > 0)
          search.append(filterName, $(select).val())
      }
    }

    return search
  }

  get searchFromFilters() {
    let search = new URLSearchParams()
    let filters = this.selectedFilters

    for (let filter of filters) {
      if (typeof(filter) === "object")
        for (let group in filter) {
          const value = filter[group]
          if (Array.isArray(value))
            search.append(`tunnel_operator_filters[${group}][]`, value[0])
          else
            search.set(`tunnel_operator_filters[${group}]`, value)
        }
      else
        search.set(`tunnel_operator_filters[${filter}]`, "1")
    }

    return search
  }
}
